import { render, staticRenderFns } from "./CkeditorCode.vue?vue&type=template&id=1c53a044"
import script from "./CkeditorCode.vue?vue&type=script&lang=js"
export * from "./CkeditorCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports